import { useState } from 'react'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { AllMeetingsTable } from './components/AllMeetingsTable'
import { CreateScheduledMeetingModal } from './components/CreateScheduledMeetingModal'

const OneOnOnesPage = () => {
  const [openCreateScheduledMeeting, setOpenCreateScheduledMeeting] = useState(false)

  return (
    <ResponsivePage.Body showHeader={false}>
      <AllMeetingsTable setOpenCreateScheduledMeeting={setOpenCreateScheduledMeeting} />
      <CreateScheduledMeetingModal
        openModal={openCreateScheduledMeeting}
        setOpenModal={setOpenCreateScheduledMeeting}
      />
    </ResponsivePage.Body>
  )
}

export default OneOnOnesPage
